import OptimumChat from '@/components/Optimum/OptimumChat'

export default () => <OptimumChat />
